import Axios from "axios";

export function getUrlPreviews(urls) {
    let previewData = {};

    urls.forEach(url => {
        previewData[url] = {};

        Axios.get(url + 'https://base-url')
            .then(response => {
                previewData[url]["data"] = response.data;
            })
            .catch(error => {
                console.log("Failed to get preview [" + url + "]")
            });
    });

    return previewData;
}